import { Button } from "@/components/Buttons";
import formStyles from "@/styles/Form.module.scss";
import processStyles from "@/styles/Process.module.scss";
import passwordResetStyles from "@/styles/PasswordReset.module.scss";
import { useDeviceInfoQuery } from "@/hooks";
import { isWebViewReact } from "@/apollo/reactives";

export default function PasswordResetComplete({ handleClick, mailAddress }) {
  const { data: { deviceInfo } = {} } = useDeviceInfoQuery({
    fetchPolicy: "cache-first",
  });
  const isWebView = isWebViewReact();
  return (
    <>
      <div className={processStyles.contentWrapper}>
        <div className={processStyles.content}>
          <p className={processStyles.contentHeader}>
            <span className={passwordResetStyles.mailAddress}>
              {mailAddress}
            </span>
            <span>へリンクをお送りしました。</span>
          </p>
          <p>
            登録済みのメールアドレスに、パスワード再設定のリンクをお送りしました。
          </p>
          <p
            className={`${formStyles.formInputInfo} ${passwordResetStyles.formInputInfo}`}
          >
            ※15分以内に届かない場合、迷惑フォルダーをご確認ください。また、＠skyperfect.co.jpからのメールを受信許可に設定してください。
          </p>
          <h3 className={passwordResetStyles.caution}>
            再設定のリンクから進み、トップページが表示される場合は、ログイン済みの可能性があります。右上のアイコンからログアウトを行なっていただき、再度再設定のリンクからパスワード変更をお願いします。
          </h3>
        </div>
      </div>
      <div className={formStyles.btnArea}>
        {!isWebView && (
          <Button type="button" fillColor large fontFixed onClick={handleClick}>
            ログインページに戻る
          </Button>
        )}
      </div>
    </>
  );
}
